import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import * as homeActions from '../../actions/home';
import * as scoredBoardActions from '../../actions/scoreBoard';
import {bindActionCreators} from 'redux';
import ScoreBoardComp from './scoreBoardComp';
import C_R from '../../constants/routes';
import CustomHelmet from '../utils/CustomHelmet';
import intlC from '../../constants/intl';
import Breadcrumbs from '../Breadcrumbs';



export class Scoreboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowAll: props.location.pathname === C_R.SCOREBOARD_PATH
        }
    }

    componentWillMount() {
        this.props.homeActions.getWidgets().then(() => {
            this.props.scoreboardActions.getscoreBoardTabs(this.state.isShowAll);
        });
    }

    render() {
        let HelmetElem = '';
        let breadcrumbsDisplay = false;
        if (this.state.isShowAll) {
            HelmetElem =
                <CustomHelmet>
                    <title>{`${this.props.intlObject['ssp.page.title.scoreboard']} - ${this.props.intlObject['ssp.page.title']}`}</title>
                </CustomHelmet>
            breadcrumbsDisplay = <Breadcrumbs/>;
        }

        var scoreboardGrid;
        if (this.state.isShowAll) {
            scoreboardGrid = <Col lg={10} lgOffset={1} md={12} className='noSidePadding'>
                <div className='topBottomMargin'>
                    <ScoreBoardComp isShowAll={this.state.isShowAll}/>
                </div>
            </Col>
        } else {
            scoreboardGrid = <Col lg={12} md={12} className='noSidePadding'>
                <div className='topBottomMargin'>
                    <ScoreBoardComp isShowAll={this.state.isShowAll} compact={this.props.compact}/>
                </div>
            </Col>

        }

        return (
            <Grid fluid>
                {HelmetElem}
                {breadcrumbsDisplay}
                <Row>
                    {scoreboardGrid}
                </Row>
            </Grid>
        )
    }
}

Scoreboard.propTypes = {
    homeActions: PropTypes.object.isRequired,
    scoreboardActions: PropTypes.object.isRequired,
    intlObject: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    // a narrow home page cell: the widget renders its tablet form
    compact: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
    return {
        homeActions: bindActionCreators(homeActions, dispatch),
        scoreboardActions: bindActionCreators(scoredBoardActions, dispatch)
    }
}

function mapStateToProps(state) {
    return {
        intlObject: state.intl.get(intlC.INTL_OBJECT)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Scoreboard));



// WEBPACK FOOTER //
// ./components/Scoreboard/index.js